/**
 * Copy for every way the booked-price reveal can come back unavailable. The keys
 * mirror `PriceRevealIneligibilityReason` on the backend
 * (application/quote/command_orchestrators/value_objects.py).
 */
const MESSAGE_BY_REASON: Record<PriceRevealIneligibilityReason, string> = {
  BOOKING_CANCELLED:
    "The booking on this shipment was cancelled, so there is no booked price to compare against.",
  SHIPMENT_NOT_BOOKED:
    "The booked price comparison is available once this shipment is booked.",
  NO_QUOTE_FROM_CARRIER:
    "The booked price comparison is only available on shipments where you have placed a quote and did not book the shipment.",
  UNSUPPORTED_SHIPMENT_TYPE:
    "The booked price comparison is not available on this kind of shipment.",
};

/**
 * Returns undefined when the API sends no reason, which happens whenever the
 * frontend is deployed ahead of the backend that added the field. The card then
 * shows its heading alone rather than guessing at a reason.
 */
export function getUnavailableMessage(
  reason: PriceRevealIneligibilityReason | undefined,
): string | undefined {
  return reason && MESSAGE_BY_REASON[reason];
}
